<template lang="html">
  <v-container style="margin-top: 1em;">

    <h2> ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ </h2> <br> <br>

    Betadigitis прагне зберегти вашу впевненість і довіру до конфіденційності особистої інформації, яку ми отримуємо від вас. <br> <br> Будь ласка, уважно прочитайте цю політику конфіденційності, щоб зрозуміти нашу практику щодо того, як ми збираємо, використовуємо та надаємо вашу особисту інформацію.

    <br> <br> <strong> Про нашу політику конфіденційності </strong> <br>

    Ця політика конфіденційності описує, як особиста інформація, що збирається під час використання програми Betadigitis, буде використана BetaDigitis.

    <br> <br> <strong> Інформація, яку ми збираємо </strong> <br>

    Служба збирає інформацію від вас двома способами: безпосередньо з вашого входу і автоматично через технології Служби.

    <br> <br> <strong> Інформація, яку ви надаєте </strong> <br>

    Типи особистої інформації, яку служба збирає безпосередньо від вас, може включати:
    <ul>
     <li> Контактні дані, такі як ваше ім’я, адреса електронної пошти, поштова адреса та номер телефону; </li>
     <li> Імена користувачів і паролі. </li>
    </ul>
    <br> Для того, щоб отримати доступ до певного контенту та скористатися додатковими функціональними можливостями Сервісу, ми просимо Вас зареєструватися на рахунок, заповнивши та подавши реєстраційну форму, яка може вимагати додаткової інформації.

    <br> <br> Якщо ви вирішили зареєструватися та ввійти в систему за допомогою облікового запису третьої сторони (наприклад, вашого облікового запису Facebook), аутентифікація вашого облікового запису обробляється третьою стороною, і служба збирає ваше ім'я, адресу електронної пошти та будь-яку іншу інформацію про ваш обліковий запис третьої сторони, з яким ви погоджуєтеся ділитися з нами під час надання дозволу на приєднання облікового запису до служби до вашого облікового запису третьої сторони.

    <br> <br> <strong> Інформація збирається автоматично </strong> <br>

    Служба також автоматично збирає, через наші програми та інші технології, інформацію, яка повідомляє нам про те, як ви використовуєте Службу, наприклад:
    <ul>
     <li> Адреса Інтернет-протоколу ("IP"), яка використовується для підключення комп'ютера до Інтернету. </li>
     <li> GPS-локалізація; </li>
     <li> Інформація про пристрій і підключення, наприклад тип і версію веб-переглядача, операційну систему, мобільну платформу і унікальний ідентифікатор пристрою ("UDID") та інші технічні ідентифікатори; </li>
     <li> Дані потоку кліків на основі уніфікованого ресурсу ("URL"), включаючи позначки дати й часу, URL-адреси посилання та виходу, використані вами пошукові терміни та сторінки, які ви відвідали або шукали в службі; і </li>
     <li> Для послуг, пов’язаних із місцезнаходженням, фізичне розташування пристрою, щоб надати вам більш релевантний вміст для того, де ви знаходитесь у світі. </li>
    </ul>
    <br> <br> Ми можемо використовувати та розголошувати інформацію, яка не розкриває вашу особистість або дозволяє безпосередньо спілкуватися з будь-якою конкретною особою, наприклад, інформацію про веб-переглядач і пристрої, анонімні дані про використання та агреговану інформацію для будь-яких цілей, крім випадків, коли ми обмежені законом. Якщо ми поєднуємо не особисту інформацію з особистою інформацією, об'єднана інформація буде розглядатися як особиста інформація, доки вона залишатиметься разом.

    <br> <br> <strong> Використання інформації </strong> <br> Ми можемо використовувати вашу особисту інформацію для:
    <ul>
     <li> Визначити та проаналізувати тенденції використання, у тому числі для цілей дослідження, аудиту, звітності; </li>
     <li> Повідомляти про зміни або оновлення Служби та наших продуктів і послуг. </li>
    </ul>
    <br> <br> <strong> Ваш вибір і налаштування комунікацій </strong> <br>


    Ви можете керувати своїми налаштуваннями зв'язку, коли ви реєструєтесь у Службі, оновлюючи налаштування облікового запису, використовуючи механізм відмови або відписки або інші засоби, надані в повідомленнях, які ви отримуєте від нас, або звернувшись до нас. Ми залишаємо за собою право повідомити Вас про зміни або оновлення Служби, коли це необхідно.

    <br> <br> <strong> Доступ до інформації та її точність </strong> <br>

    Служба може дозволити зареєстрованим користувачам отримати доступ до інформації про свій обліковий запис і внести виправлення або оновлення після входу в будь-який час. Точність такої інформації є виключно відповідальністю користувача. Ви також можете запитати доступ до інших особистих відомостей про Вас, які можуть зберігатися в Службі. Якщо ви вимагаєте відключити свій обліковий запис або видалити вашу особисту інформацію, ми намагатимемося виконати ваш запит, але деякі особисті дані можуть зберігатися в резервних копіях протягом певного періоду часу і можуть зберігатися як необхідно для законних ділових цілей або для дотримання наших юридичні зобов'язання.

    <br> <br> <strong> Безпека даних </strong> <br>

    Betadigitis береться за обережність, щоб захистити вашу особисту інформацію від втрати, крадіжки та неправомірного використання, несанкціонованого доступу, розкриття, зміни та знищення за допомогою відповідних адміністративних, фізичних та технічних заходів безпеки.

    <br> <br> <strong> Зміни нашої політики конфіденційності </strong> <br>
    Ми можемо час від часу змінювати цю політику конфіденційності. Будь-які зміни будуть опубліковані на цій сторінці з оновленою датою перегляду.

    <br> <br> <strong> Контакти </strong> <br>

    Якщо у Вас виникли питання, коментарі або запити щодо цієї політики конфіденційності або нашої обробки інформації, будь ласка, звертайтеся: contact@betadigtis.com

    <br> <br> Ця політика конфіденційності була оновлена ​​11 квітня 2019 року.
    
</v-container>
</template>

<script>
export default {
  data() {
    return {
      icons: [
        'fab fa-facebook',
        'fab fa-twitter',
        'fab fa-linkedin'
      ]
    }
  }
}
</script>

<style lang="css" scoped>
</style>
